import request from '@/utils/request'
function list (params) {
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(params)) {
    qsParams.append(key, value);
  }
  //console.log(`api.member.list: qsParams = ${qsParams.toString()}`);
  return request({
    url: `/latest?${qsParams.toString()}`,
    method: 'get',
    data: params
  })
}
export default {
    list,
}
  